module.exports = __webpack_public_path__ + "img/لوکس.94637377.jpg";